export enum WayToEnterCarInformationEnum {
  ai = 'ai',
  manual = 'manual',
}
